import type { BadgeVariants, IconProps, StsIconName } from '@packages/ui/shared';
import type { ComponentProps, ReactNode } from 'react';

import { Icon, TextBadge } from '@packages/ui/shared';

const ICON_SIZE = 16;

/** Props for {@link Ssm5IconBadge}. */
export type Ssm5IconBadgeProps = Pick<ComponentProps<typeof TextBadge>, 'style' | 'textStyle'> & {
    /** The text of the badge. */
    children: ReactNode;
    /** The icon before the text. */
    icon: StsIconName;
    /** The color of the icon. */
    iconColor: NonNullable<IconProps['color']>;
    /** The badge variant that fills the badge. */
    variant: BadgeVariants;
};

/**
 * A text badge led by a 16px icon of the font, as the SSM5 chips and badges draw it.
 *
 * @param props - {@link Ssm5IconBadgeProps}
 * @returns the badge
 */
export function Ssm5IconBadge({ children, icon, iconColor, style, textStyle, variant }: Ssm5IconBadgeProps) {
    return (
        <TextBadge
            icon={<Icon color={iconColor} name={icon} size={ICON_SIZE} />}
            style={style}
            textStyle={textStyle}
            variant={variant}
        >
            {children}
        </TextBadge>
    );
}
